"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCredentials = exports.envPrefix = void 0;
const fs = __importStar(require("fs"));
exports.envPrefix = 'BUILDER_NODE';
function setCredentials(credsdir, index, driver, endpoint) {
    let url;
    try {
        url = new URL(endpoint);
    }
    catch (e) {
        return [];
    }
    switch (url.protocol) {
        case 'tcp:': {
            return setBuildKitClientCerts(credsdir, index, driver, url);
        }
    }
    return [];
}
exports.setCredentials = setCredentials;
function setBuildKitClientCerts(credsdir, index, driver, endpoint) {
    const driverOpts = [];
    const buildkitCacert = process.env[`${exports.envPrefix}_${index}_AUTH_TLS_CACERT`] || '';
    const buildkitCert = process.env[`${exports.envPrefix}_${index}_AUTH_TLS_CERT`] || '';
    const buildkitKey = process.env[`${exports.envPrefix}_${index}_AUTH_TLS_KEY`] || '';
    if (buildkitCacert.length == 0 && buildkitCert.length == 0 && buildkitKey.length == 0) {
        return driverOpts;
    }
    let host = endpoint.hostname;
    if (endpoint.port.length > 0) {
        host += `-${endpoint.port}`;
    }
    if (buildkitCacert.length > 0) {
        const cacertpath = `${credsdir}/cacert_${host}.pem`;
        fs.writeFileSync(cacertpath, buildkitCacert);
        driverOpts.push(`cacert=${cacertpath}`);
    }
    if (buildkitCert.length > 0) {
        const certpath = `${credsdir}/cert_${host}.pem`;
        fs.writeFileSync(certpath, buildkitCert);
        driverOpts.push(`cert=${certpath}`);
    }
    if (buildkitKey.length > 0) {
        const keypath = `${credsdir}/key_${host}.pem`;
        fs.writeFileSync(keypath, buildkitKey);
        driverOpts.push(`key=${keypath}`);
    }
    if (driver != 'remote') {
        return [];
    }
    return driverOpts;
}
